import { ProductTable } from "../types/subproductTable";

const stripTagsFromProductTable = (
    productTable: ProductTable,
    removedTags: string[]
): ProductTable => {
    const subProducts = productTable.rows.reduce((acc, subProductId) => {
        return {
            ...acc,
            [subProductId]: {
                ...productTable.subProducts[subProductId],
                tags: productTable.subProducts[subProductId].tags.filter(
                    (tag) => !removedTags.includes(tag)
                ),
            },
        };
    }, {} as ProductTable["subProducts"]);
    return {
        ...productTable,
        subProducts,
    };
};

export default stripTagsFromProductTable;
